import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '@app/core/services/modal-manager/modal-component';
import { ToolsService } from '@app/core/services';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'insert-mandatory-fields-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormsModule, NgbDatepickerModule, SharedModule],
  templateUrl: './insert-mandatory-fields.component.html',
  styleUrls: ['./insert-mandatory-fields.component.scss'],
})
export class InsertMandatoryFieldsComponent extends ModalComponent {
  protected toolsService: ToolsService = inject(ToolsService);
  protected formGroup?: FormGroup;
  protected now = new Date();
  private formBuilder: FormBuilder = inject(FormBuilder);
  /**
   * Handle the 'Cancel/close' choice of the user;
   */
  reject(): void {
    this.close(false);
  }

  /**
   * Handle the 'Confirm' choice of the user
   * and emit the values of the form;
   */
  confirm(): void {
    if (!this.formGroup?.valid) {
      this.toolsService.markFormFieldsDirty(this.formGroup as FormGroup);
      return;
    }
    const values = this.formGroup.value;
    if (values.field_birth_date) {
      values.field_birth_date = this.toolsService.convertNgbDateToIsoDate(values.field_birth_date);
    }
    this.close(values);
  }

  beforeShow(): void {
    if (!this.extraData?.fields) {
      throw new Error('missing fields to open the modal');
    }
    const group: { [key: string]: any } = {};
    for (const field of this.extraData.fields) {
      group[field] = [null, Validators.required];
    }
    this.formGroup = this.formBuilder.group(group);
  }
}
